import React, { useEffect, useRef, useState } from "react";

import { CircularIndeterminate, FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { GoogleMap, Marker, LoadScript } from "@react-google-maps/api";
import { RNHAreaGet } from "services/services-mia/RNHAreaGet";
import { Box, Grid } from "@mui/material";
import { localidadesGet } from "services/services-mia/localidadesGet";
import { RNHNivelGet } from "services/services-mia/RNHNivelGet";
import { RNHHospitalIns } from "services/services-mia/RNHHospitalIns";
import { RNHUnidadGet } from "services/services-mia/RNHUnidadGet";
import { RNHZonaGet } from "services/services-mia/RNHZonaGet";

const libraries = ["places"];

const containerStyle = {
    width: "100%",
    maxWidth: "726px",
    // height: "100%",
    marginBottom: ".2rem",
    marginTop: "2rem",
    display: "flex",
    justifyContent: "end",
};

const cabeceraOpt = [
    {
        id: 0,
        value: "N",
        name: "Ninguna"
    },
    {
        id: 1,
        value: "B",
        name: "De zona y de area"
    },
    {
        id: 2,
        value: "Z",
        name: "Zona"
    },
    {
        id: 3,
        value: "A",
        name: "Área"
    },
]
export default function InsertModal({ updateList, closeModal, latitud, longitud }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [localidades, setLocalidades] = useState([]);
    const [areas, setAreas] = useState([]);
    const [niveles, setNiveles] = useState([]);
    const [unidades, setUnidades] = useState([])
    const [zonas, setZonas] = useState([])
    const [coordenadas, setCoordenadas] = useState({
        lat: latitud
            ? typeof latitud === "number"
                ? latitud
                : parseFloat(latitud)
            : -39.401045,
        lng: longitud
            ? typeof longitud === "number"
                ? longitud
                : parseFloat(longitud)
            : -66.8982459,
    });

    const [isLoading, setIsLoading] = useState(false);

    const formikRef = useRef();

    const getData = async () => {
        setIsLoading(true);
        try {
        const [areasRes, loc, niv, unidad, zona] = await Promise.all([
            RNHAreaGet(credentials),
            localidadesGet(credentials),
            RNHNivelGet(credentials),
            RNHUnidadGet(credentials),
            RNHZonaGet(credentials)
        ]);

        setZonas(zona);
        setUnidades(unidad);
        setNiveles(niv);
        setAreas(areasRes);
        setLocalidades(loc);
    } catch (error) {
        console.error('Error al obtener datos:', error);
    } finally {
        setIsLoading(false);
    }
    }
    const handleCreateHospital = async (values) => {
        const response = await RNHHospitalIns(
            credentials,
            { ...values, lat: coordenadas.lat, lng: coordenadas.lng }
        );
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Hospital creado correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    }
    useEffect(() => {
        getData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                cod: "",
                name: "",
                localidadId: "",
                areaId: "",
                nivelId: "",
                cabecera: "",
                calle: "",
                numero: "",
                unidad: "",
                piso: "",
                cpa: "",
                lat: coordenadas.lat,
                lng: coordenadas.lng
            }}
            validationSchema={
                yup.object({
                    cod: yup.string("Debe ingresar un Código").max(20, "Debe tener menos de 20 caracteres").required("Debe ingresar un Código"),
                    name: yup.string("Debe ingresar un nombre").max(100, "Debe tener menos de 100 caracteres").required("Debe ingresar un nombre"),
                    calle: yup.string("Debe ingresar una calle").max(70, "Debe tener menos de 70 caracteres").required("Debe ingresar una calle"),
                    numero: yup.string("Debe ingresar un numero").max(10, "Debe tener menos de 10 caracteres").required("Debe ingresar un numero"),
                    localidadId: yup.string("Debe seleccionar una localidad").required("Debe seleccionar una localidad"),
                    areaId: yup.string("Debe seleccionar un área").required("Debe seleccionar un área"),
                    nivelId: yup.string("Debe seleccionar un nivel").required("Debe seleccionar un nivel"),
                })
            }
            onSubmit={(values) => {
                handleCreateHospital(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid width={"100%"}>
                        {!isLoading && <Box display={"flex"} flexDirection={"column"} width={"100%"} gap={1}>
                            <Box display={"flex"} width={"100%"} gap={2}>
                                <FormikTextInput
                                    fullWidth={true}
                                    name="cod"
                                    labelText="Código"
                                />
                                <FormikTextInput
                                    fullWidth={true}
                                    name="name"
                                    labelText="Nombre"
                                />
                            </Box>
                            <Box display={"flex"} width={"100%"} gap={2}>
                                <FormikSelectInput
                                    fullWidth={true}
                                    name="nivelId"
                                    labelText="Nivel"
                                    onChange={(e) => {
                                        formikRef.current.setFieldValue("nivelId", e.target.value);
                                    }}
                                >
                                    <option value={""} selected disabled >
                                        Seleccione
                                    </option>
                                    {niveles.map(({ rnhNivelId, rnhNivelNombre }) => (
                                        <option
                                            key={rnhNivelId}
                                            data-id={rnhNivelId}
                                            value={rnhNivelId}
                                        >
                                            {rnhNivelNombre}
                                        </option>
                                    ))}
                                </FormikSelectInput>
                                <FormikSelectInput
                                    fullWidth={true}
                                    name="zonaId"
                                    labelText="Zona"
                                    onChange={(e) => {
                                        formikRef.current.setFieldValue("zonaId", e.target.value);
                                    }}
                                >
                                    <option value={""} selected disabled >
                                        Seleccione
                                    </option>
                                    {zonas.map(({ rnhZonaId, rnhZonaNombre }) => (
                                        <option
                                            key={rnhZonaId}
                                            data-id={rnhZonaId}
                                            value={rnhZonaId}
                                        >
                                            {rnhZonaNombre}
                                        </option>
                                    ))}
                                </FormikSelectInput>
                                <FormikSelectInput
                                    fullWidth={true}
                                    name="areaId"
                                    labelText="Área"
                                    onChange={(e) => {
                                        formikRef.current.setFieldValue("areaId", e.target.value);
                                    }}
                                >
                                    <option value={""} selected disabled >
                                        Seleccione
                                    </option>
                                    {areas.map(({ rnhAreaId, rnhAreaNombre, rnhAreaVersion }) => (
                                        <option
                                            key={rnhAreaId}
                                            data-id={rnhAreaVersion}
                                            value={rnhAreaId}
                                        >
                                            {rnhAreaNombre}
                                        </option>
                                    ))}
                                </FormikSelectInput>
                                <FormikSelectInput
                                    fullWidth={true}
                                    name="cabecera"
                                    labelText="Cabecera"
                                    onChange={(e) => {
                                        formikRef.current.setFieldValue("cabecera", e.target.value);
                                    }}
                                >
                                    <option value={""} selected disabled >
                                        Seleccione
                                    </option>
                                    {cabeceraOpt.map(({ id, name }) => (
                                        <option
                                            key={id}
                                            data-id={id}
                                            value={id}
                                        >
                                            {name}
                                        </option>
                                    ))}
                                </FormikSelectInput>
                            </Box>
                        </Box>}
                        <Box display={"flex"} width={"100%"} gap={2}>
                            {isLoading ? <div style={{ minWidth: "30%" }}><CircularIndeterminate /></div> : <Box display={"flex"} flexDirection={"column"} minWidth={"30%"} gap={1}>
                                <h3 style={{ margin: "0", marginTop: "8px" }}>Domicilio</h3>
                                <Box display={"flex"} width={"100%"} gap={2}>
                                    <FormikTextInput
                                        fullWidth={true}
                                        name="calle"
                                        labelText="Calle"
                                    />
                                    <FormikTextInput
                                        fullWidth={true}
                                        name="numero"
                                        labelText="Numero"
                                    />
                                </Box>
                                <Box display={"flex"} width={"100%"} gap={2}>
                                    <FormikTextInput
                                        fullWidth={true}
                                        name="piso"
                                        labelText="Piso"
                                    />
                                    <FormikTextInput
                                        fullWidth={true}
                                        name="unidad"
                                        labelText="Unidad"
                                    />
                                </Box>
                                <Box display={"flex"} width={"100%"} gap={2}>
                                    <FormikSelectInput
                                        fullWidth={true}
                                        name="localidadId"
                                        labelText="Localidad"
                                        onChange={(e) => {
                                            formikRef.current.setFieldValue("localidadId", e.target.value);
                                            let locCoords = localidades.filter((i) => i.localidadId === Number(e.target.value));
                                            console.log(locCoords);
                                            setCoordenadas({ lat: locCoords[0].localidadGeoPINLatitud, lng: locCoords[0].localidadGeoPINLongitud });
                                        }}
                                    >
                                        <option value={""} selected disabled >
                                            Seleccione
                                        </option>
                                        {localidades.map(({ localidadId, localidadNombre }) => (
                                            <option
                                                key={localidadId}
                                                data-id={localidadId}
                                                value={localidadId}
                                            >
                                                {localidadNombre}
                                            </option>
                                        ))}
                                    </FormikSelectInput>
                                    <FormikTextInput
                                        fullWidth={false}
                                        name="cpa"
                                        labelText="CPA"
                                    />
                                </Box>
                                <Box display={"flex"} width={"100%"} gap={2}>
                                    <FormikTextInput
                                        fullWidth={true}
                                        name="lat"
                                        labelText="Latitud"
                                        readOnly={true}
                                    />
                                    <FormikTextInput
                                        fullWidth={true}
                                        name="lng"
                                        labelText="Longitud"
                                        readOnly={true}
                                    />
                                </Box>
                            </Box>}
                            <LoadScript
                                id="second-google-map-script"
                                googleMapsApiKey="AIzaSyA3CvTeFPuHo7ePjm5YOva66gR-pFWZvPc"
                                libraries={libraries}
                                style={{ width: "50%", height: "100%", display: "flex", justifyContent: "end", alignItems: "center" }}
                            >
                                <GoogleMap
                                    mapContainerStyle={containerStyle}
                                    center={coordenadas}
                                    zoom={8}
                                >
                                    <Marker position={coordenadas} draggable onDragEnd={(e) =>{
                                        setCoordenadas({
                                            lat: e.latLng.lat(),
                                            lng: e.latLng.lng(),
                                        })
                                        formikRef.current.setFieldValue("lat", e.latLng.lat().toFixed(6))
                                        formikRef.current.setFieldValue("lng", e.latLng.lng().toFixed(6))
                                    }
                                    } />
                                </GoogleMap>
                            </LoadScript>
                        </Box>
                    </Grid>

                    <FormButton
                        // inRequest={inRequest || isLoading}
                        newFormData={{ button: "Crear" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
